(function () {
  var PER = 32;

  function buildNav(grid, page, pages) {
    var nav = document.createElement('nav');
    nav.className = 'em-jspage';
    nav.setAttribute('aria-label', 'Pagination');
    var html = '';
    html += '<button type="button" class="em-jspage__btn em-jspage__btn--arrow' + (page <= 1 ? ' is-disabled' : '') + '" data-page="' + (page - 1) + '" aria-label="Page précédente">&larr;</button>';
    for (var p = 1; p <= pages; p++) {
      html += '<button type="button" class="em-jspage__btn' + (p === page ? ' is-current' : '') + '" data-page="' + p + '">' + p + '</button>';
    }
    html += '<button type="button" class="em-jspage__btn em-jspage__btn--arrow' + (page >= pages ? ' is-disabled' : '') + '" data-page="' + (page + 1) + '" aria-label="Page suivante">&rarr;</button>';
    nav.innerHTML = html;
    nav.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-page]');
      if (!btn || btn.classList.contains('is-disabled') || btn.classList.contains('is-current')) return;
      showPage(grid, parseInt(btn.dataset.page, 10));
      var top = grid.getBoundingClientRect().top + window.scrollY - 130;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
    return nav;
  }

  function showPage(grid, page) {
    var items = Array.prototype.slice.call(grid.children);
    var pages = Math.ceil(items.length / PER);
    if (page < 1) { page = 1; }
    if (page > pages) { page = pages; }
    grid.dataset.emPage = page;
    for (var i = 0; i < items.length; i++) {
      var p = Math.floor(i / PER) + 1;
      items[i].style.display = (p === page) ? '' : 'none';
    }
    var old = grid.parentNode.querySelector('.em-jspage');
    if (old) { old.parentNode.removeChild(old); }
    if (pages > 1) {
      grid.parentNode.insertBefore(buildNav(grid, page, pages), grid.nextSibling);
    }
  }

  function initGrid(grid) {
    if (!grid || grid.dataset.emPaginated === '1') { return; }
    grid.dataset.emPaginated = '1';
    if (grid.children.length > PER) { showPage(grid, 1); }
  }

  function currentGrid() {
    return document.querySelector('.collection-emeraudes #product-grid, .collection-emeraudes .product-grid');
  }

  function scan() { initGrid(currentGrid()); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  var root = document.querySelector('.collection-emeraudes') || document.body;
  new MutationObserver(function () {
    var grid = currentGrid();
    if (grid && grid.dataset.emPaginated !== '1') { initGrid(grid); }
  }).observe(root, { childList: true, subtree: true });
})();
